module.exports = __webpack_public_path__ + "static/media/eyes-diseases-icon.4e156d05.svg";